<div id="workforceContainer" class="tw-h-screen tw-w-full tw-flex">
  <mat-sidenav-container class="tw-flex-1 tw-h-full" autosize>
    <mat-sidenav-content class="tw-@container">
    <!-- main content container -->
    <div
      class="tw-flex tw-flex-col tw-gap-1 tw-p-4 tw-py-6
          @lg:tw-px-14 @xl:tw-px-16 @2xl:tw-px-20">
      <div class="tw-flex tw-justify-between tw-items-center tw-mb-4">
        <!-- Hamburger menu for mobile -->
        <button
          class="toggle-sidenav-btn tw-bg-gray-800 tw-p-2 tw-rounded tw-text-white hover:tw-bg-gray-700 @mdx:tw-hidden tw-mr-2 tw-h-10"
          (click)="toggleThinSidenav()"
          aria-label="Open menu"
          *ngIf="isSmallScreen$ | async">
          <svg
            class="tw-w-6 tw-h-6"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        <img
          src="../../assets/img/workforce_logo_white.svg"
          alt="Workforce logo"
          class="tw-h-6 tw-self-start md:tw-self-auto" />

        <app-credit-usage-indicator
          [transparentBackground]="true"
          [hideProgressBar]="false"
          class="tw-ml-auto"></app-credit-usage-indicator>

        <app-share-this-view (shareClick)="onShareClick()" class="tw-ml-auto"></app-share-this-view>
      </div>

      <div class="tw-mb-2 @md:tw-mb-4 tw-flex tw-justify-center" *ngIf="isPalMode">
        <app-alert
          alertType="info"
          [hasBorder]="false"
          [closeable]="false"
          [hideIcon]="true"
          class="tw-w-full @2xl:tw-w-6/12 @2xl:tw-min-w-[1300px]">
          <div class="tw-flex tw-flex-row tw-gap-4 tw-justify-between tw-items-center">
            <div class="tw-flex tw-flex-col tw-gap-2">
              <div class="tw-text-base @md:tw-text-lg @lg:tw-text-xl">
                You're only seeing a static snapshot of data.
              </div>
              <div class="tw-hidden @md:tw-block tw-text-sm tw-text-gray-300">
                To unlock full live data functionality and modify search criteria, please join our
                free beta.
              </div>
            </div>
            <button
              class="tw-shrink-0 tw-relative tw-inline-flex tw-items-center tw-justify-center tw-overflow-hidden tw-text-base @md:tw-text-lg tw-font-medium tw-rounded-md tw-bg-gradient-to-br tw-from-purple-600 tw-to-blue-600 hover:tw-text-white tw-text-gray-900 dark:tw-text-white tw-p-0.5">
              <span class="tw-relative tw-px-5 tw-py-2 tw-bg-gray-900 tw-text-white tw-rounded-md">
                Join Free Beta
              </span>
            </button>
          </div>
        </app-alert>
      </div>

      <!-- mode switch -->
      <div class="tw-w-full tw-flex tw-justify-center tw-mb-4 @md:tw-mb-8">
        <div
          class="mode-switch tw-flex tw-gap-4 tw-items-center tw-rounded-full tw-text-sm tw-font-medium tw-border tw-border-solid tw-border-gray-600 tw-bg-gray-700
                  tw-w-full @md:tw-w-11/12 @mdx:tw-w-10/12 @lg:tw-w-10/12 @2xl:tw-w-9/12 tw-h-[56px]"
          tourAnchor="mode-switch">
          <button
            id="workforce-people-mode-explore"
            (click)="setMode('explore')"
            class="tw-px-4 tw-py-2 tw-rounded-full tw-h-[58px] tw-w-2/4"
            [ngClass]="{
                          'tw-bg-[#102825] tw-font-medium tw-text-[#7FFFD4] tw-border-2 tw-border-solid tw-border-teal-900': mode === 'explore',
                          'tw-text-white': mode !== 'explore'
                          }">
            <span class="tw-flex tw-items-center tw-justify-center tw-gap-2">
              <mat-icon class="tw-text-[22px] tw-leading-[22px]">explore</mat-icon>
              Explore
            </span>
            <div class="tw-text-xs tw-hidden @md:tw-block">
              Browse people data with simple filters
            </div>
          </button>
          <button
            id="workforce-people-mode-search"
            (click)="setMode('search')"
            class="tw-px-4 tw-py-2 tw-rounded-full tw-h-[58px] tw-w-2/4"
            [ngClass]="{
                          'tw-bg-[#102825] tw-font-medium tw-text-[#7FFFD4] tw-border-2 tw-border-solid tw-border-teal-900': mode === 'search',
                          'tw-text-white': mode !== 'search'
                          }">
            <span class="tw-flex tw-items-center tw-justify-center tw-gap-2">
              <mat-icon class="tw-text-[22px] tw-leading-[22px]">manage_search</mat-icon>
              Search
            </span>
            <div class="tw-text-xs tw-hidden @md:tw-block">
              Perform advanced search queries on people data
            </div>
          </button>
          <button
            id="workforce-people-mode-bulk"
            (click)="setMode('bulk')"
            class="tw-px-4 tw-py-2 tw-rounded-full tw-h-[58px] tw-w-2/4"
            [ngClass]="{
                          'tw-bg-[#102825] tw-font-medium tw-text-[#7FFFD4] tw-border-2 tw-border-solid tw-border-teal-900': mode === 'bulk',
                          'tw-text-white': mode !== 'bulk'
                          }">
            <span class="tw-flex tw-items-center tw-justify-center tw-gap-2">
              <mat-icon class="tw-text-[22px] tw-leading-[22px]">storage</mat-icon>
              Bulk/API
            </span>
            <div class="tw-text-xs tw-hidden @md:tw-block">Bulk and programmatic data access</div>
          </button>
        </div>
      </div>

      <people-details
        (appliedFilter)="onAppliedFilter($event)"
        [readOnly]="isPalMode"
        *ngIf="mode === 'explore'"></people-details>
      <app-filters
        *ngIf="mode === 'search'"
        (quickBuildChange)="onQuickBuildChange($event)"></app-filters>
      <app-bulk-content *ngIf="mode === 'bulk'"></app-bulk-content>
    </div>

    <!-- Chat button removed - use /chat page instead -->
  </mat-sidenav-content>
  </mat-sidenav-container>

  <tour-step-template></tour-step-template>
</div>
